import { FormTab, FormTabProps, required } from 'react-admin';

import CraftPageSection from 'src/components/CraftPageSection';
import CraftTwoColumns from 'src/components/CraftTwoColumns';
import TextInput from 'src/inputs/TextInput';

const DetailsTab = ({ mode, ...rest }: Omit<FormTabProps, 'label'> & { mode: 'create' | 'edit' }) => (
  <FormTab label="Details" {...rest}>
    <CraftPageSection title="General">
      <CraftTwoColumns
        left={<TextInput source="path" validate={required()} autoFocus={mode === 'create'} />}
        right={null}
      />
    </CraftPageSection>
  </FormTab>
);

export default DetailsTab;
